import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto text-center">
        <div className="relative rounded-[24px] overflow-hidden h-[200px] md:h-[260px] mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20book%20montage%20artistic%20collage%20with%20vibrant%20panels%20and%20characters%20in%20warm%20coral%20and%20emerald%20green%20tones%20film%20grain%20texture%20editorial%20quality%20soft%20dreamy%20atmosphere%20clean%20composition&width=1600&height=500&seq=home-cta-bg-2026&orientation=landscape"
            alt="韩国漫画大全"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30"></div>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
          发现好故事
          <br />
          <span className="text-foreground-400 italic font-normal">从这里开始 · 每日更新</span>
        </h2>

        <p className="mt-4 text-sm text-foreground-500 max-w-lg mx-auto">
          超万部韩漫作品免费在线阅读，恋爱、悬疑、动作、奇幻……总有一部让你爱不释手
        </p>

        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 mt-8 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
        >
          立即开始阅读
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}